import React, { useState, useEffect, useRef } from 'react'

export default function IFrameComponent({ iFrameData, isEmbeded }) {
  const { Width, Height, X, Y, Url, ControlID } = iFrameData
  const urlValue = useRef('')

  useEffect(() => {
    let urlText = Url
    if (urlText.includes('https://www.youtube.com/')) {
      let splitTextArr = urlText.split('https://www.youtube.com')
      urlText = 'https://www.youtube.com/embed' + splitTextArr[1]
    } else if (urlText.includes('https://youtu.be/')) {
      let splitTextArr = urlText.split('https://youtu.be')
      urlText = 'https://www.youtube.com/embed' + splitTextArr[1]
    }
    urlValue.current = urlText
  }, [iFrameData])

  return (
    <div
      style={{
        height: isEmbeded ? Height + '%' : '100%',
        width: isEmbeded ? Width + '%' : '100%',
        top: isEmbeded ? Y : undefined,
        left: isEmbeded ? X : undefined,
        position: isEmbeded ? 'absolute' : 'relative',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#000000',
        display: 'flex',
        zIndex: 5,
        cursor: 'pointer',
        backgroundColor: 'lightblue'
      }}
    >
      <div
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <iframe
          src={urlValue.current && urlValue.current}
          title='description'
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </div>
  )
}
